export class HelpModel {
  helpText: string;
  helpUrl: string;

  constructor() {
    this.helpText = '';
    this.helpUrl = '';
  }
}
